export type PlanarFacePOIPoiType = (typeof PlanarFacePOIPoiType)[keyof typeof PlanarFacePOIPoiType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanarFacePOIPoiType = {
    PlanarFacePOI: 'PlanarFacePOI'
} as const;
